module.exports = __webpack_public_path__ + "static/media/program-antyplagiatowy-wrona-4.0bf87e07.png";